import {
  signinEndpoint,
  signupEndpoint,
  detailsEndpoint,
  logoutEndpoint,
  validateTokenEndpoint,
  userExistsEndpoint,
  passwordRecoveryEndpoint,
  userAddressesEndpoint,
  userByIdEndpoint,
  userPhoneEndpoint,
} from '@/api/microsservices/AccountsApi';
import { zipCodeNotFoundEndpoint } from '@/api/microsservices/CommerceApi';
import { acceptTermsEndpoint } from '@/api/microsservices/UserPreferencesApi';

import { verifyEmailEndpoint } from '@/api/microsservices/WSEmpiricusApi';
import qs from 'qs';

import { ICustomer, ICustomerAuth } from '@/interfaces/Customer';
import { IZipCodeNotFound } from '@/interfaces/ZipCodeNotFound';

import { validateCPF } from '@/helpers/Validation/document';
import { validateEmail } from '@/helpers/Validation/general';
import { isValid } from '@/helpers/values';


export function signin(customer: ICustomerAuth): Promise<any> {
  return signinEndpoint.post({
    ...validateCPF(customer.username) && { document: customer.username },
    ...validateEmail(customer.username) && { email: customer.username },
    password: customer.password,
  });
}

export function signup(customer: ICustomer): Promise<any> {
  return signupEndpoint.post(customer);
}

export function details(): Promise<any> {
  return detailsEndpoint.get({
    timeout: 5000,
  });
}

export function logout(): Promise<any> {
  return logoutEndpoint.post();
}

export function validateToken(token: any): Promise<any> {
  return isValid(token)
    ? validateTokenEndpoint.get({
      params: {
        token,
      },
    }) : Promise.reject();
}

export function userExists(username: string): Promise<any> {
  return userExistsEndpoint.get({
    params: {
      ...validateCPF(username) && { document: username },
      ...validateEmail(username) && { email: username },
    },
  });
}

export function passwordRecovery(username: string): Promise<any> {
  return passwordRecoveryEndpoint.post({
    ...validateCPF(username) && { document: username },
    ...validateEmail(username) && { email: username },
    username,
  });
}

export function sendAcceptTerms(termsAccept: { idUser: number | string, optin?: boolean | null }): Promise<any> {
  return acceptTermsEndpoint.post(termsAccept);
}

export function verifyEmail(email: string): Promise<any> {
  const data = {
    emailAddress: email,
    sourceId: 'lojaempiricus',
  };

  return verifyEmailEndpoint.post(qs.stringify(data));
}

export function zipCodeNotFound(zipCodeNotFoundCustomer: IZipCodeNotFound): Promise<any> {
  return zipCodeNotFoundEndpoint.post(zipCodeNotFoundCustomer);
}

export function addCustomerAddress(userId: number, address: any): Promise<any> {
  return userAddressesEndpoint.post(address, {
    uriParams: {
      userId,
    },
  });
}

export function getCustomerAddresses(userId: number): Promise<any> {
  return userAddressesEndpoint.get({
    uriParams: {
      userId,
    },
  });
}

export function updateCustomer(customer: ICustomer): Promise<any> {
  const { acta_user_id, ...payload } = customer;

  return userByIdEndpoint.put(payload, {
    uriParams: {
      userId: Number(acta_user_id),
    },
  });
}

export function updateCustomerById(customer: any): Promise<any> {
  const payload = {
    email: customer.email,
    document: customer.document,
    birthday: customer.birthday,
  };

  return userByIdEndpoint.put(payload, {
    uriParams: {
      userId: customer.acta_user_id,
    },
  });
}

export function userPhoneCreate(payload: any): Promise<any> {
  return userPhoneEndpoint.post(payload.phone, {
    uriParams: {
      id: payload.userId,
    },
  });
}
